"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6752],{

/***/ 66752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var TabItem = function(param) {
    var title = param.title, icon = param.icon, active = param.active, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        onClick: onClick,
        className: "px-6 py-2 bg-gray-200  text-primary text-base flex-1 flex justify-center items-center gap-2 ".concat(active === true ? "bg-gray-300" : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "hidden md:block font-normal",
                children: title
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (TabItem);


/***/ })

}]);